
import WelcomeBlock from "./components/WelcomeBlock";
import Services from "./components/Services";
import References from "./components/References";
import ListOfClients from "./components/ListOfClients";
import AboutUs from "./components/AboutUs";
import ProjectUs from "./components/ProjectUs";
import styled from "styled-components";
import Recommends from "./components/Recommends";
import Contact from "./components/Contact";

function Home() {
    return (
        <div>
            <div className="layout">
                <Block>
                    <WelcomeBlock/>
                </Block>
                <Block id="Services">
                    <Services/>
                </Block>
            </div>
            <Block id="References">
                <References/>
            </Block>
            <div className="layout">
                <Block id="Recommends">
                    <Recommends/>
                </Block>
                <Block>
                    <ListOfClients/>
                </Block>
            </div>
            <Block id="aboutUs">
                <AboutUs/>
            </Block>
            <Block id="ProjectUs">
                <ProjectUs/>
            </Block>
            <div>
                <Contact/>
            </div>
        </div>
    );
}

const Block = styled.div `
  padding-bottom:var(--block-padding);
`;
export default Home;
